import { t } from "i18next";
import * as z from "zod";

/**
 * Schéma du formulaire d'un taux de change (`POST /FxRates/add`,
 * guide §6.4) — taux horodaté par couple de devises.
 *
 * Factory (règle projet) : créé via `createFxRateSchema()` et mémoïsé au
 * niveau composant sur la langue courante.
 */
export const createFxRateSchema = () =>
  z.object({
    currencyFrom: z
      .string()
      .trim()
      .regex(/^[A-Z]{3}$/, { message: t("invalidFieldError") }),
    currencyTo: z
      .string()
      .trim()
      .regex(/^[A-Z]{3}$/, { message: t("invalidFieldError") }),
    effectiveAt: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
    rate: z
      .number({ invalid_type_error: t("invalidFieldError") })
      .positive({ message: t("invalidFieldError") }),
    source: z
      .string()
      .trim()
      .min(1, { message: t("requiredFieldError") }),
  });

export type FxRateFormValues = z.infer<ReturnType<typeof createFxRateSchema>>;
